import useAppUserPermissions from 'hooks/useAppUserPermissions';

const usePropertiesCreationAllowed = () => {
  const permissions = useAppUserPermissions();
  return permissions.includes('Properties:Create');
};

export default usePropertiesCreationAllowed;
